import i18n from 'Portals/Supplier/utils/i18nService'

export const MOBILE_SORTING_COLUMNS: LabelValue[] = [
	{
		label: i18n.t('pages:invoice.table.invoiceDate'),
		value: 'InvoiceDate'
	},
	{
		label: i18n.t('pages:invoice.table.invoiceAmount'),
		value: 'InvoiceAmount'
	},
	{
		label: i18n.t('pages:invoice.table.paidAmount'),
		value: 'PaidAmount'
	}
]
